import { combineReducers } from "redux";

import { roomNumberDetails } from "./reducer.roomnumber"
const roomNumberReducers = combineReducers({

  roomNumberDetails

})
export default roomNumberReducers;
